import { render, staticRenderFns } from "./DocumentApproveListTable.vue?vue&type=template&id=3fc75960&scoped=true"
import script from "./DocumentApproveListTable.vue?vue&type=script&lang=js"
export * from "./DocumentApproveListTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentApproveListTable.vue?vue&type=style&index=0&id=3fc75960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc75960",
  null
  
)

export default component.exports